import { addBmTelemetryToHeaders } from 'helpers'
import apiEndpoints from 'const/endPoint'
import { AxiosRequestConfig } from 'axios'
import { getAuthTokenParams } from 'helpers/requestParams'
import apiRequestor from 'services/apiRequestor'

export interface GetAuthTokenParams {
  authCode: string
}

/**
 * Request body for /v1/oauth2/token and /v3/oauth2/token are the same.
 */
export interface GetAuthTokenRequest {
  grant_type: string
  code: string
  client_id: string
  redirect_uri: string
  code_verifier: string
}

/**
 * Response from /v1/oauth2/token and /v3/oauth2/token contain additional fields
 * which are not consumed in the application.
 */
export interface GetAuthTokenResponse {
  access_token: string
}

const authTokenAPI = {
  getAuthToken: async (
    payload: GetAuthTokenParams
  ): Promise<GetAuthTokenResponse> => {
    const headerParams = addBmTelemetryToHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    })

    const requestConfig: AxiosRequestConfig<GetAuthTokenRequest> = {
      url: apiEndpoints.authToken,
      method: 'POST',
      headers: { ...headerParams },
      data: getAuthTokenParams(payload)
    }

    const response = await apiRequestor<GetAuthTokenResponse>({
      requestConfig,
      urlencoded: true
    })

    return response.data
  },
  getV3AuthToken: async (params: GetAuthTokenParams) => {
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    }

    const requestConfig: AxiosRequestConfig<GetAuthTokenRequest> = {
      url: apiEndpoints.authTokenV3,
      method: 'POST',
      headers,
      data: getAuthTokenParams(params)
    }

    const response = await apiRequestor<GetAuthTokenResponse>({
      requestConfig,
      urlencoded: true
    })

    return response.data
  }
}

export default authTokenAPI
